import React, { Component } from "react";
import "../../assets/styles/styles.scss";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import Metadata from "../../components/Metadata";
import logo from "../../assets/images/mdkd_logo.svg";

class DeleteAccount extends Component {
  render() {
    return (
      <div className="delete-account-page">
        <Metadata title="Suppression du compte" />

        <header className="delete-account-header">
          <div className="container">
            <Link to="/">
              <img src={logo} className="logo" alt="Logo Medik'Dom" />
            </Link>
            <h1 className="title">Suppression de compte</h1>
            <p className="subtitle">
              Demandez la suppression de votre compte et de toutes vos données personnelles.
            </p>
          </div>
        </header>

        <main className="delete-account-main container">
          <section className="delete-account-section">
            <h2>Comment faire votre demande</h2>
            <p>
              Cliquez sur le bouton ci-dessous pour envoyer un email à notre équipe. Incluez votre nom complet et l'adresse email associée à votre compte.
            </p>
            <a
              href="mailto:contact@medik-dom.fr?subject=Demande%20de%20suppression%20de%20compte"
              className="delete-account-button"
            >
              Envoyer ma demande
            </a>
          </section>

          <section className="delete-account-section">
            <h2>Sécurité et confidentialité</h2>
            <p>
              Toutes vos informations sont protégées et ne seront jamais partagées avec des tiers, sauf obligations légales. Les données anonymisées peuvent être conservées à des fins statistiques ou légales.
            </p>
          </section>
        </main>

        <Footer />

        <style jsx>{`
          .delete-account-page {
            display: flex;
            flex-direction: column;
            min-height: 100vh;
          }

          .delete-account-header {
            background-color: #f8f9fa;
            padding: 40px 20px;
            text-align: center;
          }

          .delete-account-header .logo {
            max-width: 120px;
            margin-bottom: 20px;
          }

          .delete-account-header .title {
            font-size: 2rem;
            margin-bottom: 10px;
            color: #333;
          }

          .delete-account-header .subtitle {
            font-size: 1rem;
            color: #666;
          }

          .delete-account-main {
            flex: 1;
            padding: 40px 20px;
            max-width: 800px;
            margin: 0 auto;
          }

          .delete-account-section {
            margin-bottom: 40px;
          }

          .delete-account-section h2 {
            font-size: 1.5rem;
            margin-bottom: 15px;
            color: #222;
          }

          .delete-account-section p {
            font-size: 1rem;
            color: #555;
            line-height: 1.6;
          }

          .delete-account-button {
            display: inline-block;
            margin-top: 20px;
            padding: 12px 24px;
            background-color: #007bff;
            color: #fff;
            text-decoration: none;
            border-radius: 8px;
            font-weight: 600;
            transition: background-color 0.3s ease;
          }

          .delete-account-button:hover {
            background-color: #0056b3;
          }

          @media (max-width: 600px) {
            .delete-account-header .title {
              font-size: 1.5rem;
            }

            .delete-account-section h2 {
              font-size: 1.2rem;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default DeleteAccount;
